import { useTranslation } from "react-i18next";
import { List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import { formatInstallationDate } from "@utils/dateFormat";
import { IAppointment } from "@features/cart/ICart";
import { EAppointmentSlot } from "@constants";
import { useStyle } from "@features/confirmation/style";
import { DateChange } from "@features/confirmation/components/DateChange";
import { BroadbandInfo } from "@features/confirmation/components/BroadbandInfo";

interface IParams {
    appointment: IAppointment;
}

export const ConfirmationFullInstall = (props: IParams) => {
    const { appointment } = props;
    const { t } = useTranslation("confirmation");

    const { classes } = useStyle();

    const getTimeSlot = (time: EAppointmentSlot) => {
        if (time === EAppointmentSlot.AM) {
            return t("timeSlotMorning");
        }

        return t("timeSlotAfternoon");
    };

    return (
        <Stack spacing={2}>
            <Typography color="secondary" component="p" gutterBottom variant="normal">
                {t("appointmentInfo")}
            </Typography>
            {appointment.at && appointment.time && (
                <div className={classes.installationDate}>
                    <Typography color="secondary" variant="normal">
                        {formatInstallationDate(new Date(appointment.at))}, {getTimeSlot(appointment.time)}
                    </Typography>
                </div>
            )}
            <List className={classes.list}>
                <ListItem className={classes.listItem}>
                    <ListItemText primary={t("fullInstallTextMessage")} />
                </ListItem>
                <ListItem className={classes.listItem}>
                    <ListItemText primary={<DateChange isFullInstall />} />
                </ListItem>
                <ListItem className={classes.listItem}>
                    <ListItemText primary={t("equipmentTechnician")} />
                </ListItem>
            </List>
            <BroadbandInfo />
        </Stack>
    );
};
